import { GetOperateStore,GetOperate,AddOperate,ExcelOperateCode } from '@/api/code'
export default {
  state: {

  },
  actions: {
    GetOperateStore ({ commit }, payload) {
      return new Promise(resolve => {
        GetOperateStore(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetOperate ({ commit }, payload) {
      return new Promise(resolve => {
        GetOperate(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    AddOperate ({ commit }, payload) {
      return new Promise(resolve => {
        AddOperate(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ExcelOperateCode ({ commit }, payload) {
      return new Promise(resolve => {
        ExcelOperateCode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
